import { WF_ACTION_CALENDAR_EVENT } from '@/constants/workflows/wf-action-event';
import { WF_ACTION_WEBINAR } from '@/constants/workflows/wf-action-webinar';
import { IPutAfterConfirmingBookingWorkflowRequest } from '@/types/workflows/IPutAfterConfirmingBookingWorkflowRequest';
import {
	Box,
	Divider,
	FormControl,
	Heading,
	IconButton,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Select,
} from '@chakra-ui/react';

import InfoLabel from '@/components/InfoLabel';
import { WF_ACTION_OOO } from '@/constants/workflows/wf-action-ooo';
import { t } from 'i18next';
import { UseFormReturn, useForm } from 'react-hook-form';
import { BiDotsHorizontalRounded } from 'react-icons/bi';
import ActionOptions from './components/action-options/action-options.view';

interface IProps {
	index: number;
	form: UseFormReturn<IPutAfterConfirmingBookingWorkflowRequest, any>;
	onRemove: () => void;
}

export default function ActionsSection(props: IProps) {
	const form = useForm({
		defaultValues: {
			action: 'GoogleCalendarEventBookingNotification',
		},
	});

	function handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
		switch (e.target.value) {
			case 'webinar':
				props.form.setValue(`actions.${props.index}`, WF_ACTION_WEBINAR);
				break;
			case 'calendar-event':
				props.form.setValue(`actions.${props.index}`, WF_ACTION_CALENDAR_EVENT);
				break;
			case 'ooo-event':
				props.form.setValue(`actions.${props.index}`, WF_ACTION_OOO);
				break;
		}

		form.register('action').onChange(e);
	}

	return (
		<Box bg="white" p={4} borderRadius="md" borderColor="gray.100" borderWidth={1}>
			<Box display="grid" gridTemplateColumns="1fr auto" justifyContent="space-between" alignItems="center">
				<Heading size="md">{t('Action')}</Heading>
				<Menu>
					<MenuButton as={IconButton} icon={<BiDotsHorizontalRounded />} variant="ghost" />
					<MenuList>
						<MenuItem onClick={props.onRemove}>Remove action</MenuItem>
					</MenuList>
				</Menu>
			</Box>
			<Divider my={4} />
			<FormControl>
				<InfoLabel text={t('Do this')} help={''} />
				<Select {...form.register('action')} onChange={handleChange}>
					<option value="calendar-event">Create event in calendar</option>
					<option value="webinar">Create a webinar</option>
					<option value="ooo-event">Create a OOO event in calendar</option>
				</Select>
			</FormControl>

			<ActionOptions index={props.index} type={form.watch('action')} form={props.form} />
		</Box>
	);
}
